import React, { memo } from 'react';
import Slider from 'design-system/Slider';
import { rem } from 'design-system/values';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const AllocationSlider = ({ value, maximumValue, onValueChange, onSlidingStart, onSlidingComplete, step = 1, testID, sliderWidth, accessibilityLabel, }) => {
    const styles = useStyles(styleSet);
    return (<Slider testID={testID} minimumValue={0} maximumValue={100} maximumSelectableValue={maximumValue} step={step} value={value} width={sliderWidth} accessibilityLabel={accessibilityLabel} onValueChange={onValueChange} onSlidingStart={onSlidingStart} onSlidingComplete={onSlidingComplete} thumbStyle={styles.thumb} trackStyle={styles.track}/>);
};
const styleSet = createStyleSheets((colors) => ({
    thumb: {
        backgroundColor: colors.cards.onDark,
        width: rem(20),
        height: rem(20),
        borderWidth: rem(5),
        borderColor: colors.gradients.ultimate.colors[0],
        borderRadius: rem(10),
    },
    track: {
        height: rem(4),
        borderRadius: rem(22),
    },
}));
export default memo(AllocationSlider);
